export const hashEmail = (email: string): string => {
  let hash = 0;

  for (let i = 0; i < email.length; i++) {
    const char = email.toLowerCase().charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash;
  }

  return `${Math.abs(hash).toString(16)}`;
};
